import * as React from "react";
const CheckmarkIcon = ({ fill = "#fff" }) => (
  <svg
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.978 7.169a.73.73 0 0 0-.515.236c-.194.203-1.545 1.661-2.931 3.156-1.17 1.261-2.05 2.206-2.458 2.645l-2.618-2.094a.72.72 0 0 0-.556-.155.74.74 0 0 0-.497.303.82.82 0 0 0-.146.584.8.8 0 0 0 .29.521l3.147 2.517a.723.723 0 0 0 .984-.068c.193-.204 1.545-1.662 2.93-3.157 1.387-1.494 2.807-3.025 2.913-3.136a.82.82 0 0 0 .17-.872.75.75 0 0 0-.713-.48"
      fill={fill}
    />
  </svg>
);
export default CheckmarkIcon;
